module.exports = __webpack_public_path__ + "img/rope_Braid_1eye_4.4dfa9a09.png";